import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Pagination, Table, Button, Loader, Dimmer } from 'semantic-ui-react';
import { format } from 'date-fns';
import {
  getEmployeeSlots,
  openUpdateRenewalStatusModal,
  setEmployeeActionsPage,
  setEmployeeSlotsPage,
  setSelectedUpdateRenewalStatusIndex,
} from 'state/business/actions';
import UpdateRenewalStatusConfirmationModal from './UpdateRenewalStatusConfirmationModal';

const EmployeeActions = props => {
  const {
    purchasedEmployeeSlots,
    employeeActionsPage,
    allBusiness,
    dispatch,
    updatingEmployeeSlotIsRenewableStatus,
    gettingEmployeeSlots,
  } = props;

  useEffect(() => {
    const businessId = allBusiness.data[allBusiness.activeIndex].id;
    dispatch(setEmployeeSlotsPage(1));
    dispatch(setEmployeeActionsPage(1));
    dispatch(getEmployeeSlots({ businessId }));
  }, [allBusiness.activeIndex, allBusiness.data, dispatch]);

  const size = 10;
  let totalPages = 1;
  if (purchasedEmployeeSlots)
    totalPages = Math.ceil(purchasedEmployeeSlots.length / size);

  const handleOnPageChange = (_, val) => {
    const { activePage } = val;
    dispatch(setEmployeeActionsPage(activePage));
  };

  const handleOnUpdateRenewalStatusClick = index => {
    dispatch(setSelectedUpdateRenewalStatusIndex(index));
    dispatch(openUpdateRenewalStatusModal());
  };

  return (
    <>
      <UpdateRenewalStatusConfirmationModal />
      <Dimmer
        active={updatingEmployeeSlotIsRenewableStatus || gettingEmployeeSlots}
      >
        <Loader size="massive">Loading</Loader>
      </Dimmer>
      <div
        style={{
          'overflow-x': 'scroll',
        }}
      >
        <Table celled>
          <Table.Header>
            <Table.Row textAlign="center">
              <Table.HeaderCell>Slot ID</Table.HeaderCell>
              <Table.HeaderCell>Name</Table.HeaderCell>
              <Table.HeaderCell>Status</Table.HeaderCell>
              <Table.HeaderCell>Expiration Date</Table.HeaderCell>
              <Table.HeaderCell>Action</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {purchasedEmployeeSlots &&
            allBusiness.data[allBusiness.activeIndex].billing_cycle !==
              'Expired' ? (
              purchasedEmployeeSlots
                .slice(
                  (employeeActionsPage - 1) * size,
                  employeeActionsPage * size
                )
                .map((employee, index) => {
                  let keys = '';
                  Object.keys(employee).forEach(key => {
                    keys += employee[key];
                  });
                  return (
                    <Table.Row textAlign="center" key={`${keys}-purchased`}>
                      <Table.Cell key={`${keys}slotId`}>
                        {employee.id}
                      </Table.Cell>
                      <Table.Cell key={`${keys}staffName`}>
                        {employee.employee
                          ? `${employee.employee.first_name} ${employee.employee.last_name}`
                          : '-'}
                      </Table.Cell>
                      <Table.Cell
                        key={`${keys}statusStr`}
                        style={{
                          color: 'green',
                        }}
                      >
                        {employee.is_renewable
                          ? 'Active'
                          : `Active until ${format(
                              new Date(employee.expire_date),
                              'dd/MM/yyyy'
                            )}`}
                      </Table.Cell>
                      <Table.Cell key={`${keys}expirationDate`}>
                        {format(new Date(employee.expire_date), 'dd/MM/yyyy')}
                      </Table.Cell>
                      <Table.Cell key={`${keys}action`}>
                        <Button
                          fluid
                          color={employee.is_renewable ? 'yellow' : 'blue'}
                          onClick={() =>
                            handleOnUpdateRenewalStatusClick(
                              index + size * (employeeActionsPage - 1)
                            )
                          }
                        >
                          {employee.is_renewable ? 'Stop Renewal' : 'Activate'}
                        </Button>
                      </Table.Cell>
                    </Table.Row>
                  );
                })
            ) : (
              <></>
            )}
          </Table.Body>
          {purchasedEmployeeSlots ? (
            <Table.Footer>
              <Table.Row>
                <Table.HeaderCell colSpan="7">
                  <Pagination
                    activePage={employeeActionsPage}
                    totalPages={totalPages}
                    onPageChange={handleOnPageChange}
                    size="mini"
                  />
                </Table.HeaderCell>
              </Table.Row>
            </Table.Footer>
          ) : (
            <></>
          )}
        </Table>
      </div>
    </>
  );
};

const mapStateToProps = ({ business }) => ({
  purchasedEmployeeSlots: business.purchasedEmployeeSlots,
  employeeActionsPage: business.employeeActionsPage,
  allBusiness: business.allBusiness,
  gettingEmployeeSlots: business.gettingEmployeeSlots,
  updatingEmployeeSlotIsRenewableStatus:
    business.updatingEmployeeSlotIsRenewableStatus,
});

EmployeeActions.propTypes = {
  dispatch: PropTypes.func.isRequired,
  purchasedEmployeeSlots: PropTypes.object.isRequired,
  employeeActionsPage: PropTypes.object.isRequired,
  allBusiness: PropTypes.object.isRequired,
  gettingEmployeeSlots: PropTypes.bool.isRequired,
  updatingEmployeeSlotIsRenewableStatus: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps)(EmployeeActions);
